module.exports = __webpack_public_path__ + "img/shopcart_white.5ff4ec38.svg";